import { set } from 'vue/types/umd'
import { ClientType } from '../apollo'
import { ApolloQueryResult, types } from '../types'

import { createOneCommerceOrder, updateOneCommerceOrder, findManyCommerceOrder, findUniqueCommerceOrder, deleteOneCommerceOrder, updateManyCommerceOrder } from '@dinosband/bv-main-schema/dist/client-gql'

interface Mutations {
  createOneCommerceOrder: types.CommerceOrder
  updateOneCommerceOrder: types.CommerceOrder
  deleteOneCommerceOrder: types.CommerceOrder
  updateManyCommerceOrder: types.BatchPayload
}

type MutationResult = ApolloQueryResult<Mutations>

export async function createCommerceOrder (client: ClientType, data: types.CommerceOrderCreateInput): Promise<types.CommerceOrder> {
  const result = await client.mutate({
    mutation: createOneCommerceOrder,
    variables: {
      data,
    } as types.MutationCreateOneCommerceOrderArgs,
  }) as MutationResult
  return result.data.createOneCommerceOrder
}

export async function updateCommerceOrder (client: ClientType, id: number, data: types.CommerceOrderUpdateInput): Promise<types.CommerceOrder> {
  const result = await client.mutate({
    mutation: updateOneCommerceOrder,
    variables: {
      where: { id },
      data,
    } as types.MutationUpdateOneCommerceOrderArgs,
  }) as MutationResult
  return result.data.updateOneCommerceOrder
}

export async function updateCommerceOrders (client: ClientType, ids: number[], data: types.CommerceOrderUpdateManyMutationInput): Promise<types.CommerceOrder[]> {
  const result = await client.mutate({
    mutation: updateManyCommerceOrder,
    variables: {
      where: { id: { in: ids } },
      data,
    } as types.MutationUpdateManyCommerceOrderArgs,
  }) as MutationResult
  if (result.data.updateManyCommerceOrder.count == ids.length) {
    const orders = await client.query({
      query: findManyCommerceOrder,
      variables: {
        where: { id: { in: ids } },
      } as types.QueryFindManyCommerceOrderArgs,
    })
    return orders.data.findManyCommerceOrder
  }
  return []
}

export async function updateCommerceOrderStateAndDetail (client: ClientType, id: number, state: types.CommerceOrderFoodState, orderDetail?: Record<string, unknown>): Promise<types.CommerceOrder> {
  const data: types.CommerceOrderUpdateInput = orderDetail ? {
    state: {
      set: state,
    },
    orderDetail: orderDetail,
  } : {
    state: {
      set: state,
    },
  }
  return await updateCommerceOrder(client, id, data)
}

export async function updateManyCommerceOrderState (client: ClientType, ids: number[], state: types.CommerceOrderFoodState): Promise<types.CommerceOrder[]> {
  const data: types.CommerceOrderUpdateInput = {
    state: {
      set: state,
    },
  }
  return await updateCommerceOrders(client, ids, data)
}


export async function updateManyCommerceOrderRider (client: ClientType, ids: number[], state: types.CommerceOrderFoodState, riderId: number, riderUserId: number): Promise<types.CommerceOrder[]> {
  const stateInfo = `${state}@${riderId}@${riderUserId}`
  const data: types.CommerceOrderUpdateInput = {
    state: {
      set: stateInfo,
    },
  }
  return await updateCommerceOrders(client, ids, data)
}

export async function readCommerceOrders (client: ClientType, where: types.CommerceOrderWhereInput, cursor?: number, take?: number, orderBy?: types.CommerceOrderOrderByWithRelationInput[]): Promise<types.CommerceOrder[] | undefined> {
  const result = await client.query({
    query: findManyCommerceOrder,
    variables: {
      where,
      orderBy: orderBy ?? [
        { id: 'desc' },
      ],
      cursor: cursor ? { id: cursor } : undefined,
      skip: cursor ? 1 : undefined,
      take,
    } as types.QueryFindManyCommerceOrderArgs,
  })
  return result.data.findManyCommerceOrder
}

export async function readCommerceOrder (client: ClientType, id: number): Promise<types.CommerceOrder | undefined> {
  const result = await client.query({
    query: findUniqueCommerceOrder,
    variables: {
      where: { id },
    } as types.QueryFindManyCommerceOrderArgs,
  })
  return result.data.findUniqueCommerceOrder
}

export async function deleteCommerceOrder (client: ClientType, id: number): Promise<types.CommerceOrder> {
  const result = await client.mutate({
    mutation: deleteOneCommerceOrder,
    variables: {
      where: { id },
    } as types.MutationDeleteOneCommerceOrderArgs,
  }) as MutationResult
  return result.data.deleteOneCommerceOrder
}